import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendFundTransferAdviceDd } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const FundTransferAdviceDirectDebit = (props) => {
  const {
    goToAmountBlock,
    goToFundTransferDirectDebit,
    sendType,
    fundTransferAdviceDd,
    isLoading,
  } = props;

  const handleFundTransferAdviceDd1 = () => {
    const payload = {
      type: "valid_mandate_ref",
    };
    sendType(payload);
  };

  const handleFundTransferAdviceDd2 = () => {
    const payload = {
      type: "balance_enquiry",
    };
    sendType(payload);
  };

  const request = fundTransferAdviceDd && fundTransferAdviceDd.request;
  const response = fundTransferAdviceDd && fundTransferAdviceDd.response;

  return (
    <InwardXml
      prev={goToFundTransferDirectDebit}
      next={goToAmountBlock}
      title={"Fund Transfer Advice Direct Debit"}
      request={request}
      response={response}
      optiontitle1={"Valid Mandate Ref"}
      optiontitle2={"Balance Enquiry (BE)"}
      handleCase1={handleFundTransferAdviceDd1}
      handleCase2={handleFundTransferAdviceDd2}
      isLoading={isLoading}
    />
  );
};

FundTransferAdviceDirectDebit.propTypes = {
  fundTransferAdviceDd: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToAmountBlock: PropTypes.func,
  goToFundTransferDirectDebit: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendFundTransferAdviceDdSuccess:
      state.inwardInteraction.sendFundTransferAdviceDdSuccess,
    fundTransferAdviceDd: state.inwardInteraction.sendFundTransferAdviceDd,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendFundTransferAdviceDd(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundTransferAdviceDirectDebit);
